module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/training-unit-lvl2-75.435db135.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/training-unit-lvl2-75.png
// module id = 3566
// module chunks = 11